import { useSessionStorage } from 'shared/src/composables/storage/useSessionStorage';
import { computed, ComputedRef, Ref } from 'vue';
import { AuthModel } from '../models/authorizationState.model';
import { Profile } from '../services/Authorization.contracts';

export class AuthorizationModuleStore {
  private authorizationState: Ref<AuthModel | any> = useSessionStorage('authorizationState', {});

  changeUserLoginStatus(isLogged: boolean): void {
    this.authorizationState.value = { ...this.authorizationState.value as AuthModel, isLogged };
  }

  setUserAuth(authObj: AuthModel | any): void {
    this.authorizationState.value = { ...this.authorizationState.value, ...authObj };
  }

  clearAuthorizationState(): void {
    sessionStorage.removeItem('sessionId');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('logout');
    sessionStorage.setItem('logoutInProgress', 'true');
    this.authorizationState.value = {};
  }

  get isUserLogged(): boolean {
    return !!this.authorizationState.value?.isLogged;
  }

  get UserCurrentAuthorizationState(): AuthModel | null {
    return this.authorizationState.value;
  }

  get UserAccessToken(): string | undefined {
    return this.authorizationState.value?.access_token;
  }

  get UserAccessTokenComputedRef(): ComputedRef<string | undefined> {
    return computed(() => {
      return this.authorizationState.value?.access_token;
    });
  }

  public get UserIdToken(): string | undefined {
    return this.authorizationState.value?.id_token;
  }

  public get UserProfile(): Profile | undefined {
    return this.authorizationState.value?.profile;
  }

  public get State(): Record<string, any> | undefined {
    return this.authorizationState.value?.state;
  }

  public get ExpiresAt(): number | undefined {
    return this.authorizationState.value?.expires_at;
  }

  public get getAuthMethod(): string | undefined {
    return this.authorizationState.value?.profile.idp;
  }

  public get isOrganization(): boolean | undefined {
    return !!this.authorizationState.value?.profile.orgid;
  }

  public get authErrorState(): string | undefined {
    return this.authorizationState.value?.authErrorState;
  }

  public get userSid(): string | undefined {
    return this.authorizationState?.value?.profile?.sid;
  }

  public get userMid(): string | undefined {
    return this.authorizationState?.value?.profile?.mid;
  }
}

export default new AuthorizationModuleStore;